import { useMyTeamRole } from '../../team/useMyTeamRole';

/**
 * True for a member of the workspace (not the owner). A member never sees a price or a checkout
 * button on an upsell surface: the owner note shows in its place. While `team.list` loads, the
 * answer is false, as for every other checkout gate (`useMyTeamRole`). The upsell reads the role
 * through this one hook, so a screen test gets a default for it (`jest.setuptests.ts`).
 */
export function useIsUpsellMember(): boolean {
  return useMyTeamRole() === 'MEMBER';
}
